import PropTypes from 'prop-types'
import React, {Fragment} from 'react'

import ProductSetSlider from './ProductSetSlider'

const ProductSetSliderWrapper = ({formattedItems, title}) => (
  <div className="product-set-slider-wrapper">
    {formattedItems.length > 0 && (
      <Fragment>
        <h2 className="product-set-slider__title">{title}</h2>
        <ProductSetSlider>{formattedItems}</ProductSetSlider>
      </Fragment>
    )}
  </div>
)

ProductSetSliderWrapper.propTypes = {
  formattedItems: PropTypes.arrayOf(PropTypes.shape({})),
  title: PropTypes.string.isRequired,
}

export default ProductSetSliderWrapper
